import { Action } from "@ngrx/store";

export const SET_COMPARATIVE_HEADER_TITLE = "SET_COMPARATIVE_HEADER_TITLE";

export class SetComparativeHeaderTitle implements Action {
  readonly type = SET_COMPARATIVE_HEADER_TITLE;
  constructor(public payload: string) {}
}

export type Actions = SetComparativeHeaderTitle;
